import React from "react";
import PropTypes from "prop-types";
import radium from "radium";
import Icon from "../icon";
import ProviderLogo from "../providerLogo";

function Rating({ amount, max, description, provider, icon }) {
  const ratingMap = {
    0: "0_0",
    0.5: "0_5",
    1: "1_0",
    1.5: "1_5",
    2: "2_0",
    2.5: "2_5",
    3: "3_0",
    3.5: "3_5",
    4: "4_0",
    4.5: "4_5",
    5: "5_0",
  };

  const label = amount ? `${amount} rating` : "";

  const iconDimensions = {
    height: "12px",
    width: "100px",
  };

  return (
    <div
      className="Rating"
      title={label}
    >
      {amount && icon && ratingMap[amount] &&
        <Icon
          name={`rating-${ratingMap[amount]}`}
          label={label}
          dimensions={iconDimensions}
        />
      }

      {((amount && icon && !ratingMap[amount]) || (amount && !icon)) &&
        <div style={{ display: "inline-block" }}>
          {description && `${description} `}
          <span itemProp="ratingValue">{amount}</span>
          {max && ` out of ${max}`}
        </div>
      }

      {provider &&
        <ProviderLogo
          provider={provider}
          style={{
            float: "right",
            height: "21px",
            marginTop: "-4px",
          }}
        />
      }
    </div>
  );
}

Rating.propTypes = {
  /**
   * A numeric value, 0-5
   */
  amount: PropTypes.number,

  /**
   * A number that defines the maximum rating value
   */
  max: PropTypes.number,

  /**
   * A word that describes the rating, i.e., excellent, great, poor, etc.
   */
  description: PropTypes.string,

  /**
   * If the rating comes from a third-party
   */
  provider: PropTypes.oneOf([
    "",
    "bdc",
    "hostelworld",
    "opentable",
    "gadventures",
    "viator",
  ]),

  /**
   * Should the rating use an icon instead of text to describe the rating
   */
  icon: PropTypes.bool,
};

Rating.defaultProps = {
  amount: "",

  max: 5,

  text: "",

  provider: "",

  icon: false,
};

export default radium(Rating);


// WEBPACK FOOTER //
// ./assets/pois/components/rating/index.jsx